import React from "react";
import { graphql, Link } from "gatsby";

import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { renderRichText } from "gatsby-source-contentful/rich-text";

import Layout from "../components/layout";

import Header from "../components/organisms/header";
import Footer from "../components/organisms/footer";
import Section from "../components/organisms/section";
import FormContact from "../components/organisms/form-contact";
import FormWrapper from "../components/organisms/form-wrapper";

import HeaderBrand from "../components/molecules/header-brand";
import FooterBrand from "../components/molecules/footer-brand";
import FooterNav from "../components/molecules/footer-nav";
import FooterCopy from "../components/molecules/footer-copy";
import NavBar from "../components/molecules/navbar";
import HeaderTitle from "../components/molecules/header-title";
import Image from "../components/molecules/image";
import Hero from "../components/molecules/hero";

const helpers = require("../helpers");

import Seo from "../components/atoms/seo";
import Button from "../components/atoms/button";
import DictionaryEntry from "../components/atoms/dictionary-entry";

import "../scss/molecules/_rich-text.scss";

class FreePageTemplate extends React.Component {
  render() {
    const dictionaryEdges = this.props.data.allContentfulDictionaryEntry.edges;
    const pageItem = this.props.pageContext[this.props.pageContext.language];
    const hasDirectCta = pageItem.formTitle && pageItem.formTitle.length;
    const richTextOptions = {
      renderNode: {
        [INLINES.HYPERLINK]: (node, children) => {
          if (node.data.uri.indexOf("/") === 0) {
            // local path
            return (
              <Link to={helpers.getTrailedUrl(node.data.uri)}>{children}</Link>
            );
          }
          return (
            <a href={node.data.uri} target="_blank">
              {children}
            </a>
          );
        },
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          if (!node.data || !node.data.target) {
            console.warn("Embedded asset fields was undefined");
            return <></>;
          }

          let linkedAsset = this.props.data.allContentfulAsset.edges.find(
            (x) => {
              return (
                x.node["contentful_id"] ==
                  node.data.target.sys.id.substring(1) ||
                x.node["contentful_id"] == node.data.target.sys.id
              );
            }
          );

          if (!linkedAsset || !linkedAsset.node) {
            console.warn("LinkedAsset was undefined");
            return <></>;
          }

          const { title, description, file } = linkedAsset.node;
          const mimeType = file.contentType;
          const mimeGroup = mimeType.split("/")[0];

          if (linkedAsset === undefined) {
            return (
              <span style={{ backgroundColor: "red", color: "white" }}>
                Missing: {node.data.target.sys.id}
              </span>
            );
          }

          switch (mimeGroup) {
            case "image":
              return (
                <div className="rich-text-media">
                  <Image
                    src={file.url}
                    fluid={linkedAsset.node.fluid}
                    // fixed={linkedAsset.node.fixed}
                    alt={linkedAsset.node.title}
                    extension={file.url.split(".").slice(-1)[0]}
                    maxWidth={file.details.image.width}
                  />
                </div>
              );
            case "application":
              return (
                <a alt={description ? description : null} href={file.url}>
                  {title ? title : file.details.fileName}
                </a>
              );
            default:
              return (
                <span style={{ backgroundColor: "red", color: "white" }}>
                  {" "}
                  {mimeType} embedded asset{" "}
                </span>
              );
          }
        },
      },
    };

    return (
      <Layout location={this.props.location}>
        <Seo
          title={pageItem.title}
          media={pageItem.media.file.url}
          description={pageItem.introduction.introduction}
        />
        <Header darkBg={true}>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
          <Hero
            src={pageItem.media ? pageItem.media.file.url : ""}
            fluid={pageItem.media ? pageItem.media.fluid : ""}
            noBrand={true}
            noGradient={pageItem.removeGradient}
          />
        </Header>
        <Section className="mt-2 pt-5 pb-7 mb-6">
          <div className="row">
            <div className="col-md-8 mx-auto">
              <HeaderTitle title={pageItem.title} small={true} />

              <div className="rich-text">
                {pageItem.body
                  ? renderRichText(pageItem.body, richTextOptions)
                  : ""}
              </div>
            </div>
          </div>
        </Section>
        <Section className="pt-0 pb-0 section-grey" isFluid={true}>
          <div className="row">
            <div className="col-md-3 mr-auto">
              <Image
                fluid={this.props.data.collaborateImage.childImageSharp.fluid}
                alt={helpers.getShortValueFromDictionary(
                  dictionaryEdges,
                  "free-page.contact-alt-image",
                  this.props.pageContext.language
                )}
                overlay="gradient"
                negateLeft={true}
                negateTop={true}
                aspectRatio="1x3"
              />
            </div>
            <div className="col-md-8 d-flex py-5">
              {!hasDirectCta ? (
                <div className="mt-auto mb-auto">
                  <p className="h3 mb-4">
                    <DictionaryEntry
                      dictionaryEdges={dictionaryEdges}
                      dictionaryKey="free-page.contact-title"
                      language={this.props.pageContext.language}
                    />
                  </p>
                  <Button to="contact" type="clean">
                    <DictionaryEntry
                      dictionaryEdges={dictionaryEdges}
                      dictionaryKey="free-page.contact-cta"
                      language={this.props.pageContext.language}
                    />
                  </Button>
                </div>
              ) : (
                <FormWrapper path={pageItem.path}>
                  <FormContact
                    dictionaryEdges={dictionaryEdges}
                    language={this.props.pageContext.language}
                    inContainer={true}
                    copy={{
                      title: pageItem.formTitle,
                      disclaimer: pageItem.formDisclaimer,
                      submit: pageItem.formSubmit,

                      // email: pageItem.email,
                      // firstName: pageItem.firstName,
                      // lastName: pageItem.lastName,
                      // message: pageItem.message,

                      stateSuccess: pageItem.formStateSuccess,
                      stateError: pageItem.formStateError,
                    }}
                  />
                </FormWrapper>
              )}
            </div>
          </div>
        </Section>

        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    collaborateImage: file(
      relativePath: {
        eq: "background/felipe-furtado-2zDXqgTzEFE-unsplash_2.png"
      }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 1000) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allContentfulAsset(filter: { node_locale: { eq: "en-EU" } }) {
      edges {
        node {
          contentful_id
          title
          fluid(maxWidth: 1200, quality: 100) {
            aspectRatio
            src
            srcSet
            sizes
          }
          file {
            url
            details {
              image {
                width
              }
            }
            contentType
          }
        }
      }
    }
    allContentfulDictionaryEntry(
      filter: { key: { regex: "/(free-page|contact.form)/i" } }
    ) {
      edges {
        node {
          key
          shortValue
          richValue {
            raw
          }
          node_locale
        }
      }
    }
  }
`;

export default FreePageTemplate;
